import { DropdownContext } from 'components/DropdownContext';
import type {
    BimChapterEnum,
    BimWorkOrderChangeObjectData,
    WorkOrderChangeStatusEnum,
    WorkOrderStatusEnum,
} from 'gql/graphql';
import type { IListItem } from 'types/Contract';
import { cnMixSpace, IconArrowDown } from 'uikit';

import { BimWorkOrderChangeUploadOther } from '../BimWorkOrderChangeUploadOther';
import { BimWorkOrderChangeUploadPrices } from '../BimWorkOrderChangeUploadPrices';

import { BimWorkOrderChangeUploadModalName, useBimWorkOrderUploadMenu } from './hooks';

interface IBimWorkOrderChangeUploads {
    isDisabled: boolean;
    workOrderChangeStatus: WorkOrderChangeStatusEnum | undefined;
    workOrderStatus: WorkOrderStatusEnum | undefined;
    workOrderChangeId: number;
    chapter: BimChapterEnum | undefined;
    selectedObject: IListItem<number> | undefined;
    constructionTypeId: number | undefined;
    makeRefreshCurrentTable: () => void;
    objectsListItems: BimWorkOrderChangeObjectData[];
}

export const BimWorkOrderChangeUploads = ({
    isDisabled,
    workOrderChangeStatus,
    workOrderStatus,
    workOrderChangeId,
    chapter,
    selectedObject,
    makeRefreshCurrentTable,
    constructionTypeId,
    objectsListItems,
}: IBimWorkOrderChangeUploads) => {
    const { menuItems, openedModalType, closeModalsHandler } = useBimWorkOrderUploadMenu({
        workOrderChangeStatus,
        workOrderStatus,
        chapter,
    });

    return (
        <>
            <DropdownContext
                wrapperClassName={cnMixSpace({ mR: 'xs' })}
                items={menuItems}
                btnView="primary"
                btnSize="s"
                btnIconSize="xs"
                btnLabel="Добавить"
                icon={IconArrowDown}
                isDisabled={isDisabled}
            />
            {openedModalType[BimWorkOrderChangeUploadModalName.Price] && (
                <BimWorkOrderChangeUploadPrices
                    workOrderChangeId={workOrderChangeId}
                    selectedObject={selectedObject}
                    onClose={closeModalsHandler}
                    bimChapter={chapter}
                    refreshTable={makeRefreshCurrentTable}
                />
            )}
            {openedModalType[BimWorkOrderChangeUploadModalName.Other] && (
                <BimWorkOrderChangeUploadOther
                    onClose={closeModalsHandler}
                    refreshTable={makeRefreshCurrentTable}
                    constructionTypeId={constructionTypeId}
                    workOrderChangeId={workOrderChangeId}
                    objectsListItems={objectsListItems}
                />
            )}
        </>
    );
};

BimWorkOrderChangeUploads.displayName = 'BimWorkOrderChangeUploads';
